import { format, isValid, parseISO } from 'date-fns';

const hasTimezone = (value: string): boolean => /Z|[+-]\d{2}:\d{2}$/.test(value);

const utcToLocalDateTimeInput = (value?: string | Date | null): string => {
  if (!value) return '';

  const date = typeof value === 'string' ? parseISO(hasTimezone(value) ? value : `${value}Z`) : value;

  return isValid(date) ? format(date, "yyyy-MM-dd'T'HH:mm") : '';
};

export default utcToLocalDateTimeInput;
